import React from "react";
import { axiosAuthInstance } from "../../../axios/auth.axios";

function Logout() {
    const logout = async () => {
        await axiosAuthInstance.get("auth/logout");
        localStorage.clear();
        window.location.reload();
    };
    logout();
    return <div></div>;
}

export default Logout;
